<section>
  <div class="container-fluid bg-lightgrey py-5">
    <h1 class="h3 text-center">FAQ</h1>
  </div>
  <div class="container-narrow py-5">
    <p>
      <b>Come mai avete pensato a questa iniziativa?</b><br>
      Da diversi anni il tema dell’immigrazione e quello dell’accoglienza di richiedenti asilo e rifugiati è stato
      centrale nel dibattito politico. Le discussioni su questo fenomeno però sono troppo spesso basate su posizioni
      ideologiche prive di basi concrete. A nostro parere invece è fondamentale che il dibattito su una politica
      pubblica così importante sia basato su dati di fatto ed elementi concreti.
    </p>
    <p>
      <b>Non ci pensa già il Governo?</b><br>
      Il governo, in particolare il ministero dell’interno, mette a disposizione alcune informazioni. Si tratta però
      quasi sempre di dati aggregati e parziali che non permettono analisi di dettaglio sul fenomeno. Il documento più
      importante rilasciato in quest’ambito ad esempio è la relazione annuale che il ministero fa al parlamento. Ogni
      anno tuttavia la relazione viene pubblicata con mesi di ritardo e comunque fornisce dati aggregati e non in
      formato aperto. Ad oggi quindi Centri d’Italia è la prima piattaforma a mettere a disposizione di chiunque e in
      formato aperto dati di dettaglio sul sistema di accoglienza.
    </p>
    <p>
      <b>Quali sono le fonti dei dati?</b><br>
      I dati sono il frutto di richieste di accesso agli atti presentate da ActionAid e openpolis al ministero
      dell’interno.
    </p>
    <p>
      <b>Si prevede un aggiornamento dei dati?</b><br>
      Certo, l’aggiornamento previsto è annuale.
    </p>
    <p>
      <b>I dati presenti sono affidabili?</b><br>
      Tutti i dati presenti nella piattaforma provengono da una fonte ufficiale. Questi però presentano molti problemi
      di coerenza e completezza. In alcuni casi quindi abbiamo dovuto compiere delle scelte per risolvere problemi di
      incongruità.
    </p>
    <p>
      <b>Ci sono dei problemi relativi alla serie storica di ciascun centro?</b><br>
      I dati ufficiali non riportano dei veri e propri identificativi univoci per ciascun centro. Per ricostruire la
      storia di ogni singolo centro dunque abbiamo proceduto con lavorazioni automatiche e semiautomatiche partendo dai
      dati forniti per ciascuna delle annualità presenti. I principali indicatori utilizzati per determinare che anno
      dopo anno si stia parlando sempre dello stesso centro sono stati il nome della struttura e l’indirizzo.
    </p>
    <p>
      <b>Ci sono dei problemi relativi alla geolocalizzazione?</b><br>
      Anche quando ci vengono forniti, per ragioni di sicurezza e riservatezza degli ospiti non possiamo fornire gli indirizzi precisi. In ogni caso
      anche questo campo presenta alcune criticità rispetto alla fonte ufficiale. Gli indirizzi non sono infatti sempre
      presenti e anche quando lo sono non hanno un formato univoco. In ogni caso mettiamo a disposizione le informazioni
      sul comune in cui è collocato il centro. Inoltre dalle mappe è possibile avere un’indicazione di massima sull’area
      in cui si trova il centro.<br>
      Inoltre può accadere che nella pagina di un comune siano presenti dei centri SAI / SAPROIMI / SPRAR geolocalizzati
      in un comune limitrofo. Questo perché nella pagina di un comune sono inseriti i centri SAI / SAPROIMI / SPRAR
      attivati da quello stesso ente locale. Indipendentemente dal fatto che la struttura sia effettivamente collocata
      in quello stesso comune o in uno adiacente.
    </p>
    <p>
      <b>Perché alcuni centri hanno un nome “strano” (i.e. SPRAR-64fh8g oppure CAS-7h974n)?</b><br>
      Alcuni centri riportavano come nome esattamente l’indirizzo del centro. Per ragioni di sicurezza il nome
      contenente l’indirizzo è stato oscurato e gli è stato attribuito un codice.
    </p>
    <p>
      <b>Che cos’è la classe del comune?</b><br>
      Si tratta di una classificazione con cui vengono individuati i comuni polo, cintura e le aree interne. <a
      href="https://www.openpolis.it/parole/che-cosa-sono-le-aree-interne/">Qui</a> puoi avere maggiori informazioni al
      riguardo.
    </p>
    <p>
      <b>A quali date si riferiscono di preciso le informazioni?</b><br>
      Per quanto riguarda i centri governativi, ovvero i Cas e la prima accoglienza, i dati si riferiscono al 31
      dicembre di ciascun anno. Si tratta dunque di una fotografia a un momento esatto. Quindi se un centro è stato
      chiuso prima di quella data non rientrerà nei dati presenti. Si tratta di un aspetto da tenere presente in
      particolare rispetto alle presenze. Questo è infatti un dato molto suscettibile al momento della rilevazione.<br>
      Per quanto riguarda i dati su Sai / Siproimi / Sprar, per i dati sul 2023 vale lo stesso ragionamento.
      Per il periodo precedente invece si deve distinguere tra analisi a livello territoriale
      (aggregato nazionale, provinciale e comunale) e livello di dettaglio della singola struttura. In entrambi i casi
      per gli anni 2018 e 2019 la data di riferimento è il 31 dicembre, mentre per quanto riguarda il 2020 il dato
      aggregato va riferito al 31 ottobre. Il dato delle singole strutture invece è riferito alla data indicata come
      "data_rilevazione" nel file "Strutture Sai" scaricabile nella sezione opendata.<br>
      Tale accorgimento si è reso necessario per mancanza di altri dettagli dalla fonte e per omogeneizzare
      l’informazione complessiva tra CAS e SAI/SPRAR/SIPROIMI al maggior dettaglio comune.
    </p>
    <p>
      <b>Ci sono dei problemi relativi alla capienza (posti disponibili), le presenze e l’effettiva operatività del
        centro?</b><br>
      Sì in alcuni casi.<br>
      Rispetto ai Cas il problema più evidente si è fortunatamente presentato solo per il 2018 e solo per la prefettura
      di Venezia. In alcuni casi in questo frangente nella riga relativa a un centro era indicata una capienza molto
      elevata. La stessa identica capienza era poi riportata per molti altri centri amministrati dallo stesso ente
      gestore. In seguito a degli approfondimenti è emerso chiaramente che il dato riguardava la capienza complessiva di
      tutti i centri gestiti da quell’operatore e non di ciascuno di questi. A ogni struttura è stata quindi attribuita
      una frazione della capienza complessiva, basandoci quando possibile sui dati corretti degli anni successivi.<br>
      A partire dai dati relativi al 2020 invece oltre al campo "capienza" i dati presentano anche un campo “capienza
      effettiva”. A seguito di alcune interlocuzioni con i soggetti preposti è emerso che il campo "capienza"
      rappresenta quella formalmente prevista all'inizio, mentre il campo "capienza effettiva" quella a cui si è giunti
      in per ragioni diverse. In alcuni casi quest'ultima può essere più bassa, in particolare negli anni della pandemia
      per ridurre le occasioni di contagio, oppure più alta magari in esecuzione del "quinto d'obbligo" richiesto dalla
      prefettura in caso di carenza di posti nel sistema.
      In linea generale infine varie incongruenze sono state rilevate su ciascuna annualità rispetto a questi due
      indicatori e il campo “operatività del centro”. In alcuni casi infatti lo stesso centro era indicato come “aperto”
      ma con capienza pari a zero (in questo caso il valore di operatività del centro è stato trasformato in CHIUSO) o
      al contrario “chiuso” ma con presenze maggiori di zero.<br>
      Relativamente ai centri Sai / Siproimi / Sprar le informazioni precedenti al 2023 su presenze e capienza
      sono diverse se si guarda al
      dato aggregato o al singolo centro. Per i dati aggregati, reperibili nel file "Progetti SAI" presente nella
      sezione Opendata, le presenze si riferiscono ai beneficiari registrati e la capienza ai "posti ammessi al
      finanziamento" comunicatici dai soggetti preposti al 31 dicembre di ogni anno (ad esclusione del 2020 in cui la
      data è il 31 ottobre). Nei dati sulle singole strutture invece la capienza e le presenze si riferiscono alla data
      indicata come "data_rilevazione" nel file "Strutture Sai" scaricabile nella sezione opendata. Sempre in questo
      file sono indicate con data al 31 dicembre quelle strutture che, stando alla data di apertura e di chiusura del
      centro risultavano aperte in quel momento. Per i dati sul 2023 invece non esiste questa distinzione.
      Le presenze dunque si riferiscono sempre ai beneficiari registrati, mentre la capienza ai posti finanziati.
      È bene tenere presente dunque che la serie storica relativa al campo “Posti disponibili” (ovvero la capienza)
      per il Sai si interrompe al 2022 seguendo, a partire dal 2023,
      una metodologia differente e più aderente alla realtà.
    </p>
    <p>
      <b>Ci sono dei problemi relativi ai prezzi?</b><br>
      Sì, in alcuni casi il campo risulta vuoto, oppure pari a zero, mentre in altri è inutilizzabile, parziale o
      ambiguo. Nei casi di valore zero è stato convertito in Null in modo da non compromettere il calcolo delle medie.
      In alcuni rari casi il campo includeva più di un prezzo. Visto che i valori erano comunque simili gli è stato
      conferito un valore medio. Il dato poi è parziale per alcuni centri di prima accoglienza. Per alcune strutture di
      questo tipo infatti il contratto è suddiviso per lotti prestazionali (servizi di accoglienza, pulizia e mensa) e
      le cifre descritte potrebbero riguardare solo alcuni servizi e non tutti.<br>
      Per quanto riguarda i centri Sai / Siproimi / Sprar infine non sono disponibili informazioni sui prezzi
      giornalieri per ospite.
    </p>
    <p>
      <b>Che significa quando i posti disponibili sono “n.d.“?</b><br>
      Quando nei dati si trova “n.d” per una o più tipologie di centro vuol dire che in quel territorio (provincia o
      comune) e in quell'anno non ci sono centri attivi di quella tipologia.
    </p>
    <p>
      <b>Quale riferimento amministrativo-territoriale avete usato?</b><br>
      Il riferimento amministrativo-territoriale di comuni e province è al 01/01/2021. Ciò vuol dire che quando un
      centro si trova in un comune che non esiste più per diverse ragioni la struttura è stata reindirizzata al comune
      attualmente in essere in quel territorio.
    </p>
    <p>
      <b>Come mai sul sito non ci sono informazioni aggregate sui gestori dei centri?</b><br>
      Nei dati ufficiali ad ogni centro è associato un gestore inserito tramite un semplice campo di testo. Lo stesso
      operatore dunque può essere indicato a seconda dei casi con diciture e acronimi diversi anche se in molti casi
      simili. Questo rende però impossibile avere certezza in tutti i casi se si tratti o meno dello stesso ente gestore
      o di uno con un nome simile. Per questa ragione abbiamo sempre insistito nelle nostre richieste di accesso agli
      atti che ci venisse fornito anche il codice fiscale o la partita iva dell’ente gestore. Questa informazione
      tuttavia ci è sempre stata negata.
    </p>
    <p>
      <b>Che cosa sono le procedure di affidamento?</b><br>
      Si tratta di un campo presente negli opendata e solo per i centri governativi, ovvero i Cas e la prima
      accoglienza. Le procedure di affidamento, o procedure di scelta del contraente, sono il modo attraverso cui le
      stazioni appaltanti (nel nostro caso le prefetture) decidono come assegnare un contratto. Sono disciplinate dal
      codice degli appalti che stabilisce le situazioni e le modalità con cui possono essere utilizzate. Per
      approfondire puoi leggere <a
      href="https://www.openpolis.it/parole/cosa-sono-le-procedure-di-scelta-del-contraente/">qui</a>.
    </p>
    <p>
      <b>Che cosa si intende per Sai, i Cas e prima accoglienza?</b><br>
      Sono le 3 tipologie di centro presenti in Italia e riportate sulla piattaforma.<br>
      La prima accoglienza è a sua volta distinta in Cpa (centri di prima accoglienza), regolati dall’articolo 9 del
      decreto legislativo 142/2015, e Hotspot. I centri caratterizzati dall’approccio Hotspot, stabilito in sede
      europea, sono quelli previsti dall’articolo 10ter del decreto legislativo 286/1998.<br>
      I Cas (centri di accoglienza straordinaria) sono regolati dall’articolo 11 del decreto legislativo 142/2015 e si
      suddividono in Cas adulti e Cas minori. Fortunatamente però i Cas minori sono assolutamente residuali e di anno in
      anno sempre meno. I minori infatti dovrebbero essere accolti nel Sai o nelle strutture comunali per minori.<br>
      Il capitolato di appalto previsto per ciascuna di queste strutture è reperibile presso il <a
      href="https://www.interno.gov.it/it/amministrazione-trasparente/bandi-gara-e-contratti/nuovo-schema-capitolato-appalto-fornitura-beni-e-servizi-relativi-alla-gestione-e-funzionamento-dei-centri">sito</a>
      del ministero dell’interno.<br>
      I centri Sai sono regolati dall’articolo 1-sexies del decreto legge 416/1989. Nel corso degli anni questo tipo di
      strutture ha più volte cambiato nome (Sprar / Siproimi / Sai) e funzioni. In ogni caso queste strutture possono a
      seconda dei casi accogliere ospiti ordinari (ORD), minori stranieri non accompagnati (MSNA) o persone con disagi
      mentali e disabilità fisiche (DM-DS).<br>
      Per maggiori informazioni sul funzionamento del sistema di accoglienza puoi leggere <a
      href="https://www.google.com/url?q=https://www.openpolis.it/parole/come-funziona-laccoglienza-dei-migranti-in-italia/&sa=D&source=docs&ust=1639740178351000&usg=AOvVaw2ExBKNRSUQ43_u5w-pQUPy">qui</a>.

    </p>
    <p>
      <b>Che cosa sono i dati sui contratti pubblici e cosa bisogna sapere a riguardo?</b><br>
      Nella sezione opendata si trovano dei dati provenienti dalla Banca dati dei contratti pubblici (Bdncp)
      dell’Autorità nazionale anticorruzione (Anac). Quete informazioni sono state utilizzate per alcune analisi
      reperibili nella sezione Pubblicazioni del sito, non riguardano invece i dati che si trovano sul sito stesso. Tra
      i dati sui contratti pubblici emessi dalle prfetture italiane a partire dal 2020 sono stati selezionati quelli che
      si riferiscono alla gestione di centri di accoglienza governativi (ovvero i Cas e la prima accoglienza). I dati
      vengono periodicamente aggiornati e possono differire dai risultati presenti nelle analisi sia per quanto riguarda
      il perimetro temporale, sia perché i dati oggetto di analisi sono stati sottoposti a ulteriori elaborazioni.
    </p>
    <p>
      <b>Si possono scaricare i dati?</b><br>
      Certo e incoraggiamo a farlo! <a href="https://centriditalia.it/pages/open-data">Qui</a> trovi tutti i dati in
      formato aperto. La licenza di utilizzo è <a href="https://creativecommons.org/licenses/by/4.0/legalcode.it">CC-BY
      4.0</a>.
    </p>
    <p>
      <b>Quanto costa fare e mantenere tutto questo? E chi vi paga?</b><br>
      Il progetto è il frutto della collaborazione tra ActionAid e openpolis che lo finanziano. Non riceviamo
      contribuiti da altri soggetti.
    </p>
  </div>
</section>
